import { useSelectorTyped } from 'common/store/useSelectorTyped';
import {
  firstName,
  lastName,
  profileBio,
  profileImage,
  stateOrCountry,
} from 'admin/company/constants/usersConstants';

interface ProfileFormSettings {
  feedbackProductEnabled: boolean;
  integratedEmployees: boolean;
}

/**
 * Required keys for the profile fields only. The employee form's
 * useUserFormRequiredFields also requires role, team leader and channel, which
 * the self-service form does not render, and a required key for an unrendered
 * field would make the form unsubmittable.
 */
export function useProfileFormRequiredFields({
  feedbackProductEnabled,
  integratedEmployees,
}: ProfileFormSettings): string[] {
  const { profileImageSetting } = useSelectorTyped(state => state.company);
  const collectsProfileDetails = feedbackProductEnabled && !integratedEmployees;

  return [
    firstName.key,
    lastName.key,
    collectsProfileDetails && stateOrCountry.key,
    collectsProfileDetails && profileBio.key,
    profileImageSetting === 'users_choice' && profileImage.key,
  ].filter(Boolean) as string[];
}
